import { render, staticRenderFns } from "./AccountsModule.vue?vue&type=template&id=db26dff0"
import script from "./AccountsModule.vue?vue&type=script&lang=js"
export * from "./AccountsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports